import { CategoryItem } from '@/interfaces/categories'
import { categoriesData, categoriesIconsMap, categoriesRedirectionRules } from '@/constants/categories'

export const getCategoryInfo = (categoryName: string, fallback?: boolean): CategoryItem | null => {
  const otherCategory = categoriesData.find((category) => category.name === 'OTHER')
  return categoriesData.find((category) => category.name === categoryName) || (fallback ? otherCategory : null)
}

export const getCategorySvgIcon = (svgIconString: string): any => {
  return categoriesIconsMap[svgIconString] || null
}

export const checkIfShouldRedirectCategory = (
  categoryName: string,
  path: string
): {
  shouldRedirect: boolean
  targetUrl: string
} => {
  const { search } = new URL(path, 'http://localhost')
  const searchParams = new URLSearchParams(search)
  const pathname = `/categories/${categoriesRedirectionRules[categoryName]?.toLowerCase()}/`
  const targetUrl = `${pathname}?${searchParams.toString()}`

  return {
    shouldRedirect: Object.keys(categoriesRedirectionRules).includes(categoryName),
    targetUrl
  }
}
